/**
 * Parses a string to create a slug without non-ASCII characters.
 *
 * Example:
 * stringToSlug("café au lait") => "cafe-au-lait"
 */
export function stringToSlug(slug: string): string {
  // Replace non-ASCII characters with their closest ASCII equivalents
  const parsedSlug = slug.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Replace spaces with dashes and convert to lowercase
  return parsedSlug.trim().replace(/\s+/g, "-").toLowerCase();
}
